import {createActions} from 'redux-actions';
import api from '@api';

const actions = createActions({
  updateMe: async () => {
    const me = await api.users.getMe();
    return {me};
  },
});

export default actions;
